import { ArtifactPreviewSkeleton } from '@/components/project/ArtifactPreviewSkeleton'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { useTranslation } from '@/hooks/useTranslation'

const FILE_ROW_PLACEHOLDER_KEYS = ['a', 'b', 'c', 'd', 'e'] as const

export function ProjectDetailLoadingSkeleton() {
	const { t } = useTranslation()

	return (
		<div role="status" aria-busy="true" className="flex flex-col md:flex-1 md:min-h-0">
			<span className="sr-only">{t('common.loading')}</span>

			<section className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6 shrink-0">
				<div className="flex items-center gap-2 p-1 rounded-full bg-gray-100">
					<div className="h-9 w-[7.5rem] rounded-full bg-muted animate-pulse md:w-32" />
					<div className="h-9 w-[7.5rem] rounded-full bg-muted animate-pulse md:w-36" />
				</div>

				<div className="flex flex-wrap items-start md:justify-end gap-3 md:gap-4 pe-5 w-full md:w-auto">
					<div className="h-4 w-24 rounded bg-muted animate-pulse" />
					<div className="h-4 w-28 rounded bg-muted animate-pulse" />
					<div className="h-4 w-36 rounded bg-muted animate-pulse" />
				</div>
			</section>

			<section className="relative mt-2 md:flex-1 flex flex-col md:min-h-0 overflow-x-hidden md:overflow-y-hidden">
				<div className="w-full md:flex-1 flex flex-col md:min-h-0">
					<div className="p-2 md:flex-1 flex flex-col md:min-h-0 min-w-0">
						<section className="flex flex-col md:flex-row gap-5 mt-5 pb-20 md:pb-0 md:flex-1 md:min-h-0">
							<Card className="w-full md:w-1/3 flex flex-col min-h-[350px] md:min-h-0 md:min-w-0">
								<CardHeader className="flex flex-row flex-wrap items-center justify-between gap-3 border-b border-gray-200 shrink-0">
									<div className="flex items-center gap-2">
										<div className="size-9 rounded-full bg-muted animate-pulse" />
										<div className="h-8 w-32 rounded-md bg-muted animate-pulse md:w-40" />
									</div>
									<div className="h-10 min-w-[6.5rem] flex-1 max-w-[9rem] rounded-md bg-muted animate-pulse" />
								</CardHeader>
								<CardContent className="flex flex-col flex-1 min-h-0 min-w-0 gap-4 pt-6">
									<div className="flex flex-col gap-4 flex-1 min-h-0">
										{FILE_ROW_PLACEHOLDER_KEYS.map((key) => (
											<div
												key={key}
												className="flex w-full shrink-0 items-center gap-3 rounded-lg border border-border/60 p-3 pl-2"
												aria-hidden
											>
												<div className="size-10 shrink-0 rounded-md bg-muted animate-pulse" />
												<div className="min-w-0 flex-1 space-y-2">
													<div className="h-4 w-3/4 max-w-[12rem] rounded bg-muted animate-pulse" />
													<div className="h-3 w-24 rounded bg-muted animate-pulse" />
												</div>
											</div>
										))}
									</div>

									<div className="mt-auto flex shrink-0 flex-col gap-2 border-t border-border/40 pt-4 md:flex-row md:flex-wrap md:justify-center">
										<div className="h-10 flex-1 rounded-md bg-muted animate-pulse md:max-w-[8rem]" />
										<div className="h-10 flex-1 rounded-md bg-muted animate-pulse md:max-w-[8rem]" />
										<div className="h-10 flex-1 rounded-md bg-muted animate-pulse md:max-w-[11rem]" />
									</div>
								</CardContent>
							</Card>

							<Card className="w-full md:w-2/3 flex flex-col min-h-[280px] md:min-h-0 md:min-w-0">
								<CardHeader className="flex flex-row flex-wrap items-center justify-between gap-3 border-b border-gray-200 shrink-0">
									<div className="flex min-w-0 flex-1 items-center gap-2">
										<div className="size-6 shrink-0 rounded bg-muted animate-pulse" />
										<div className="h-6 flex-1 max-w-[14rem] rounded bg-muted animate-pulse" />
									</div>
									<div className="h-9 w-24 shrink-0 rounded-md bg-muted animate-pulse md:w-32" />
								</CardHeader>
								<CardContent className="min-h-0 flex-1 overflow-hidden p-0">
									<ArtifactPreviewSkeleton embedParentAnnouncesLoading />
								</CardContent>
							</Card>
						</section>
					</div>
				</div>
			</section>
		</div>
	)
}
